import AddShop from "../symbols/addShop";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function AddShopReducer(state = initialState, action: any) {
  switch (action.type) {
    case AddShop.ADD_SHOPS:
      return { ...state, loading: true, error: false };
    case AddShop.ADD_SHOPS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };

    case AddShop.ADD_SHOPS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case AddShop.CLEAR_ADD_SHOPS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
